import HiddenValueDots from '@components/v2/ui/HiddenValueDots/HiddenValueDots';
import { Box } from '@mui/material';
import MoneyRendererV3 from '../MoneyRendererV3/MoneyRendererV3';
import { MoneyRendererV3Props } from '../MoneyRendererV3/moneyRendererV3.types';

interface HideableMoneyRendererProps extends MoneyRendererV3Props {
  hideValue?: boolean;
}

const HideableMoneyRenderer = ({ hideValue, ...props }: HideableMoneyRendererProps) => {
  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      <Box sx={{ visibility: hideValue ? 'hidden' : undefined }}>
        <MoneyRendererV3 {...props} />
      </Box>
      {hideValue && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <HiddenValueDots />
        </Box>
      )}
    </Box>
  );
};

export default HideableMoneyRenderer;
